module.exports = __webpack_public_path__ + "cdd3de325d6fc86ba982a9a344637484.svg";